import { useParams } from "react-router";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";

export function WorkOrderCompletionFilesRoute() {
  const { workOrderId } = useParams();
  const { data: workOrder } = useVbsWorkOrderShowQuery({ id: workOrderId! });

  return (
    <DocumentBlobCard
      subdomain={GSMServiceKind.VBS}
      documentKind={GSMDocumentKind.WorkOrder}
      documentId={workOrderId!}
      disabled={workOrder?.immutable ?? false}
    />
  );
}
